/*
 * Module for the contribution rate group edit page
 */
rs.module("content/system/configuration/contributionrates/edit",

    [
        "controls/components/event-banner",
        "common/select-helper"
    ],

    function (eventBanner, selectHelper) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, backend, grid) {

            // Unpack jsSelectors
            var criteria = $.js(jsSelectors.criteria);

            var limitAddButton = criteria.js(jsSelectors.limitAddButton);
            var limitUpdateToken = criteria.js(jsSelectors.limitUpdateToken);
            var limitContributionRuleLimitKey = criteria.js(jsSelectors.limitContributionRuleLimitKey);
            var limitSingleLimitInput = criteria.js(jsSelectors.limitSingleLimitInput);
            var limitAnnualLimitAmountInput = criteria.js(jsSelectors.limitAnnualLimitAmountInput);
            var limitAnnualLimitTypeSelect = criteria.js(jsSelectors.limitAnnualLimitTypeSelect);
            var limitEffectiveDateInput = criteria.js(jsSelectors.limitEffectiveDateInput);
            var limitTerminationDateInput = criteria.js(jsSelectors.limitTerminationDateInput);
            var limitCancelButton = criteria.js(jsSelectors.limitCancelButton);

            // Grab select helper(s)
            var limitAnnualLimitTypeSelectHelper = selectHelper.getHelper(limitAnnualLimitTypeSelect);

            // On the add link button click, clear limit form
            limitAddButton.click(function () {
                clearBanner();
                grid.selectedValues = null;
                limitContributionRuleLimitKey.val(-1);
                [
                    limitUpdateToken,
                    limitSingleLimitInput,
                    limitAnnualLimitAmountInput,
                    limitEffectiveDateInput,
                    limitTerminationDateInput
                ].forEach((input) => input.clearErrors().val(''));
                limitAnnualLimitTypeSelectHelper.selectIndex(0);
            });

            // On the cancel link button click, reset the limit form
            limitCancelButton.click(function () {
                grid.selectedValues = null;
                grid.selectFirstRow();
                clearBanner();
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    var contributionRuleLimitKey = values[0];

                    $.getJSON(backend, { ruleLimitKey: contributionRuleLimitKey }).done(function (data) {

                        limitContributionRuleLimitKey.val(contributionRuleLimitKey);
                        limitUpdateToken.val(data.updateToken);
                        limitSingleLimitInput.val(data.singleLimit);
                        limitAnnualLimitAmountInput.val(data.annualLimitAmount);
                        limitEffectiveDateInput.val(data.effectiveDate);
                        limitTerminationDateInput.val(data.terminationDate);
                        limitAnnualLimitTypeSelectHelper.setValue(data.annualLimitType);

                    });

                    clearBanner();
                }

                _executeSelectionChanged = true;
            });

            // Clear the event banner of all messages.
            function clearBanner() {
                eventBanner.removeErrorMessages();
                eventBanner.removeInformationalMessages();
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);